// extracted by mini-css-extract-plugin
module.exports = {"home":"src-components-PageResult-index-module__home--1YXgT"};